// extracted by mini-css-extract-plugin
export var banner = "_ja-0";
export var closeButton = "_ja-2";
export var greenCheckmark = "_ja-3";
export var hereLink = "_ja-4";
export var titleIcon = "_ja-1";